import classNames from 'classnames';
import React, { useCallback } from 'react';
import { Post } from '../../../api/content/blog/type/post';
import { Image } from '../../atoms/image';
import { useFormatters } from '../../hooks/use-fomatters';
import * as styles from './post.module.sass';
import { PostContainerProps } from './props.types';

export const PostContainer = React.memo((props: PostContainerProps) => {
  const { formatDate, formatTime } = useFormatters();

  const {
    title,
    date,
    category,
    url,
    image,
  } = props.post;

  const correctUrl = document.location.origin + new URL(url).pathname;
  const correctImageUrl = image ? 
    'https://minio:9000/moi-server-liip/news_list_partners_photo/' + image.split('/').pop()
    : '';

  return (
    <a className={classNames(styles.post_wrapper, props.className)} href={correctUrl}>
      {image &&
        <Image
          src={image}
          alt={title}
          srcs={[]}
          className={styles.img}
        />}
      <div className={styles.post_info_wrapper}>
        <p className={styles.post_tag_name}>{category}</p>
        <p className={styles.post_date}>
          {formatDate(date)} {formatTime(date)}
        </p>
      </div>
      <p className={styles.post_description}>{title}</p>
    </a>
  );
});
